<template>
  <div>
    <JoinBanner />
    <JoinHeader />
    <JoinInfos />
    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { url } from '@zz-common/zz-utils'
import JoinBanner from '@/components/JoinBanner.vue'
import JoinHeader from '@/components/JoinHeader.vue'
import JoinInfos from '@/components/JoinInfos.vue'
import Footer from '@/components/Footer.vue'

let lang = url.getParam('lang') || ''

export default Vue.extend({
  name: 'container-view',
  components: {
    JoinBanner,
    JoinInfos,
    JoinHeader,
    Footer
  },

  created() {
    // lang如果是en，就设置为en，其它情况设置为zh-cn
    lang = lang.includes('en') ? 'en' : 'zh-cn'
    this.$store.commit('switchLang', lang)

    // 如果页面分辨率大于1280，则给html设置overflow-x: hidden
    if (window.innerWidth > 1200) {
      document.documentElement.style.overflowX = 'hidden'
    }

    if (lang === 'en') {
      document.title = 'Save money. Save the world.'
    } else {
      document.title = '二手拯救世界'
    }
  }
})
</script>
